module.exports = __webpack_public_path__ + "img/Patch5.1.32984f9f.webp";